<article class="hero-container">
  <div>
    <img class="logo" src="../../assets/images/SRS_NAME_LOGO.png" />
    <p class="tagline text">"The best way to operate your restaurant"</p>
    <button class="btn btn-cta" (click)="scrollToElement(what)">
      Learn More
    </button>
    <button class="btn btn-cta" (click)="scrollToElement(pricing)">
      Pricing
    </button>
  </div>
</article>

<article class="customers-section">
  <img src="../../assets/images/rodizio_express_logo.png" />
  <img src="../../assets/images/flycafe.png" />
  <img src="../../assets/images/romans_pizza.png" class="square" />
</article>

<div #what class="title-pill text">🤔 WHAT IS IT?</div>
<article class="about-section">
  <p class="center-paragraph text">
    Smart Restaurant Suite is a comprehensive solution designed to streamline
    your restaurant operations. From managing orders and inventory to analyzing
    sales and customer preferences, our suite provides all the tools you need to
    run your restaurant efficiently. Whether you own a small café or a large
    chain, our software scales to meet your needs, ensuring seamless operations
    and satisfied customers.
  </p>
</article>

<div class="title-pill text">🤨 WHY SRS?</div>
<article class="about-section">
  <p class="center-paragraph text">
    Effortlessly manage and expand your restaurant empire with precision and
    control. Benefit from robust oversight, theft prevention, streamlined
    operations, support for high volatility and rapid growth, long-term
    strategic analysis, seamless scalability, and deep customer insights and
    profiling.
  </p>
</article>

<div class="title-pill text">🚀 OUR KEY FEATURES</div>

<article class="feature-section">
  <img src="../../assets/images/analytics.png" />
  <div>
    <h1 class="text">Reporting and Analytics Tools</h1>
    <p class="text">
      Gain deep insights into your restaurant's performance with our
      comprehensive reporting and analytics tools. Track sales trends, customer
      preferences, and inventory levels to make informed decisions that drive
      growth and profitability.
    </p>
    <ul>
      <li class="text">Realtime reports</li>
      <li class="text">Intuitive Dashboard</li>
      <li class="text">SMS and Email Alerts</li>
      <li class="text">Detailed sales reports</li>
      <li class="text">Access level controllable</li>
      <li class="text">Key performance indicators</li>
      <li class="text">Customer behavior analytics</li>
      <li class="text">Accessible anytime anywhere</li>
      <li class="text">Inventory tracking and management</li>
    </ul>
  </div>
</article>

<article class="feature-section">
  <img class="iphone" src="../../assets/images/customer.png" />
  <div>
    <h1 class="text">Customer Ordering Platforms</h1>
    <p class="text">
      Enhance your customers' ordering experience with our versatile ordering
      platforms. Whether through mobile apps, web portals, or in-store kiosks,
      provide your customers with convenient and efficient ways to place their
      orders.
    </p>
    <ul>
      <li class="text">Mobile app ordering</li>
      <li class="text">Web portal for online orders</li>
      <li class="text">In-store self-service kiosks</li>
      <li class="text">Customizable menu interfaces</li>
      <li class="text">Real-time order tracking</li>
      <li class="text">Integration with loyalty programs</li>
      <li class="text">Multiple payment options</li>
      <li class="text">Order history and favorites</li>
      <li class="text">Push notifications for order updates</li>
    </ul>
  </div>
</article>

<article class="feature-section">
  <img src="../../assets/images/POS.png" />
  <div>
    <h1 class="text">Point Of Sale Terminal</h1>
    <p class="text">
      Our state-of-the-art POS system offers a seamless and reliable way to
      manage your sales transactions, whether you are online or offline. Track
      employee shifts, manage stock levels, and generate detailed reports to
      keep your business running smoothly.
    </p>
    <ul>
      <li class="text">Offline operability</li>
      <li class="text">Employee shift time tracking</li>
      <li class="text">Reporting and stock management</li>
      <li class="text">Elaborate customer receipt branding</li>
      <li class="text">Media display controls for TV displays</li>
      <li class="text">Wireless integrations with other terminals</li>
      <li class="text">
        Integrations with accounting systems (Quickbooks, Xerox, Freshbooks,
        Zoho, etc)
      </li>
    </ul>
  </div>
</article>

<article class="feature-section">
  <img src="../../assets/images/tablet.png" />
  <div>
    <h1 class="text">Kitchen Management Terminal</h1>
    <p class="text">
      Our kitchen management system ensures that your kitchen staff operates
      efficiently and effectively. Streamline communication between the front
      and back of house, manage orders, and monitor kitchen performance in
      real-time.
    </p>
    <ul>
      <li class="text">Order Alerts</li>
      <li class="text">Chef tracking</li>
      <li class="text">Built-in intercoms</li>
      <li class="text">Integration with POS system</li>
      <li class="text">Order tracking and management</li>
      <li class="text">Menu item preparation time tracking</li>
      <li class="text">Wireless integrations with other terminals</li>
      <li class="text">Real-time kitchen performance monitoring</li>
      <li class="text">
        Menu item category segragation possible (e.g cake only station, etc)
      </li>
    </ul>
  </div>
</article>

<article class="feature-section">
  <img src="../../assets/images/bike.png" />
  <div>
    <h1 class="text">Delivery Service</h1>
    <p class="text">
      Manage your delivery operations with ease using our delivery service
      management tools. From order dispatch to delivery tracking, ensure that
      your customers receive their orders promptly and accurately.
    </p>
    <ul>
      <li class="text">Order dispatch management</li>
      <li class="text">Real-time delivery tracking</li>
      <li class="text">Integration with third-party delivery services</li>
      <li class="text">Route optimization</li>
      <li class="text">Driver performance monitoring</li>
      <li class="text">Automated delivery notifications</li>
      <li class="text">Customer feedback and rating system</li>
      <li class="text">Delivery analytics and reporting</li>
      <li class="text">In-app driver communication</li>
    </ul>
  </div>
</article>

<div #pricing class="title-pill text">💰 Pricing</div>
<h1 class="center-paragraph text">
  We offer free data migration from your current system!
</h1>
<article class="prices-container">
  <div class="pricing">
    <div class="pricing-head"><h1 class="text">Starter Package</h1></div>
    <div class="content-container">
      <h2 class="text">P 2,350/<span>Month</span></h2>
      <ul>
        <li><p class="text">1 POS Terminal</p></li>
        <li><p class="text">1 Kitchen Terminal</p></li>
        <li><p class="text">Online Reporting Platform</p></li>
      </ul>
    </div>
    <div class="pricing-head">
      <button class="btn btn-cta" routerLink="/contact-us">Contact Us</button>
    </div>
  </div>
  <div class="pricing">
    <div class="pricing-head"><h1 class="text">Advanced Package</h1></div>
    <div class="content-container">
      <h2 class="text">P 2,900/<span>Month</span></h2>
      <ul>
        <li><p class="text">1 POS Terminal</p></li>
        <li><p class="text">1 Kitchen Terminal</p></li>
        <li><p class="text">Online Reporting Platform</p></li>
        <li><p class="text">Stock Management Platform</p></li>
      </ul>
    </div>
    <div class="pricing-head">
      <button class="btn btn-cta" routerLink="/contact-us">Contact Us</button>
    </div>
  </div>
  <div class="pricing">
    <div class="pricing-head"><h1 class="text">Premium Package</h1></div>
    <div class="content-container">
      <h2 class="text">P 3,450/<span>Month</span></h2>
      <ul>
        <li><p class="text">1 POS Terminal</p></li>
        <li><p class="text">1 Kitchen Terminal</p></li>
        <li><p class="text">Online Reporting Platform</p></li>
        <li><p class="text">Stock Management Platform</p></li>
        <li><p class="text">Customer Relationship Management</p></li>
        <li><p class="text">Accounting Software Integrations</p></li>
        <li><p class="text">Customer Ordering Platform</p></li>
        <li><p class="text">Customer Mobile Application</p></li>
        <li><p class="text">Delivery Service Eligible</p></li>
        <li><p class="text">Plus 1000/Extra Station</p></li>
      </ul>
    </div>
    <div class="pricing-head">
      <button class="btn btn-cta" routerLink="/contact-us">Contact Us</button>
    </div>
  </div>
</article>
